import React from "react";
import { useDispatch } from "react-redux";
import "../RoleName/RoleName.css";
import "../OptionBlocks.css";
import { NumberInput, Radio, Dropdown, Radio_nameonly, RadioNameonly } from "../../../../../Components";
import {
  ColumnVertical,
  ColumnHorizontal,
  AlphabeticalAtoZ,
  AlphabeticalZtoA,
  BalanceOff,
  BalanceCenter,
  Multiply,
  Bullet,
  Dimond,
  Pipeline,
  Square,
  None,
  SideAB,
  InsetOff,
  InsetLeft,
  InsetRight,
  SingleColumnRight,
  SingleColumnLeft,
  SingleColumnCenter,
  gutterJustify,
  spaceBetweenJustify,
  GutterAlignment,
  RightAlignment2,
  LeftAlignment2,
  RaggedAlignment,
} from "../../../../../assets/icons/index";
import {
  updateProjectCreditOptionsState,
  saveOptionById,
} from "../../../../../Redux/actions/projectActions";

import {
  Heading,
  Subheading,
} from "../../../../ProjectV2/Options/OptionFont/Functions";
import { useEffect, useState } from "react";

const initialOptions = [
  { label: "None", value: 0 },
  { label: "10%", value: 10 },
  { label: "20%", value: 20 },
  { label: "30%", value: 30 },
  { label: "40%", value: 40 },
  { label: "50%", value: 50 },
]
const NameOnly = ({ options, currentBlockIdx, currentBlockId, undoStack }) => {
  const dispatch = useDispatch();
  const [selectedID, setSelectedID] = useState('')
  const [option, setOptions] = useState([...initialOptions]);

  const handleChange = (key, value) => {
    switch (key) {
      case "columns":
        const new_columns = value;
        const new_column_width = Math.floor(100 / new_columns);
        dispatch(
          updateProjectCreditOptionsState(
            currentBlockIdx,
            "column_width",
            new_column_width
          )
        );
        dispatch(updateProjectCreditOptionsState(currentBlockIdx, key, value));
        break;
      default:
        dispatch(updateProjectCreditOptionsState(currentBlockIdx, key, value));
    }
  };

  useEffect(() => {
    const idx = option.findIndex((opt) => opt.value === options?.margin_vertical);
    if (idx !== -1) {
      setSelectedID(idx)
    }
  }, [options?.margin_vertical]);
  
  const saveOptions = () => {
    undoStack.push(options);
    dispatch(saveOptionById(currentBlockId));
  };

  const getValue = (value) => {
    return value ? value : "";
  };

  const conditionalColumnWidth = (val, options) => {
    const Max = 100 / options.columns;
    return parseInt(val > 0 ? (val < Max + 1 ? val : Max) : 0);
  };

  return (
    <div className="Roles-name">
      <div className="rolename-inside">
        <div className="optionSection">
          <div className="optionSectionLabel">Heading</div>
          <div className="optionSectionContent heading_padding">
            <Heading
              onChange={(val) => {
                handleChange("heading", val);
              }}
              value={getValue(options.heading)}
              onFocusOut={saveOptions}
            />
          </div>
        </div>
        <div className="optionSection">
          <div className="optionSectionLabel">Sub-Heading</div>
          <div className="optionSectionContent heading_padding">
            <Subheading
              onChange={(val) => {
                handleChange("subheading", val);
              }}
              value={getValue(options.subheading ? options.subheading : "")}
              onFocusOut={saveOptions}
            />
          </div>
        </div>
        <div className="optionSection">
          <div className="optionSectionLabel">Alignment</div>
          <div className="optionSectionContent">
            <RadioNameonly
              options={[
                {
                  icon: SingleColumnCenter,
                  value: "center",
                },
                {
                  icon: options.columns < 2 ? SingleColumnLeft : LeftAlignment2,
                  value: "left",
                },
                {
                  icon:
                    options.columns < 2 ? SingleColumnRight : RightAlignment2,
                  value: "right",
                },
                {
                  icon: gutterJustify,
                  value: options.columns < 2 ? "Right" : "gutter",
                  disabled: (options.columns < 2),
                },
                {
                  icon: spaceBetweenJustify,
                  value: options.columns < 2 ? "Left" : "justify",
                  disabled: (options.columns < 2),
                },
              ]}
              value={options.text_alignment}
              onChange={(val) => {
                handleChange("text_alignment", val);
                saveOptions();
              }}
              label={options.text_alignment}
              withIcon
            />
          </div>
        </div>
        <div className="optionSection h-14">
          <div className="optionSectionLabel">Arrangement</div>
          <div className="optionSectionContent">
            <p className="radio-nameonly">
              <input
                type="radio"
                id="colomns"
                name="nameonlyArran"
                checked={options.bullets === null}
                onClick={() => {
                  handleChange("bullets", null);
                }}
                readOnly
              />
              <label for="colomns"> Column(s) </label>
            </p>
            <div className="colomn-s">
                <NumberInput
                  postLabel=""
                  value={options.columns}
                  onChange={(val) => handleChange("columns", val)}
                  min={1}
                  max={5}
                  onFocusOut={saveOptions}
                  disabled={options.bullets !== null}
                  customBtnMargin={{marginLeft : "61px"}}
                />
            </div>
          </div>
        </div>
        <div className="optionSection h-7">
          <div className="optionSectionContent2 ">
            <p className="radio-nameonly">
              <input
                type="radio"
                id="paragraph"
                name="nameonlyArran"
                checked={options.bullets !== null}
                onClick={() => {
                  handleChange("bullets", "circle");
                }}
                readOnly
              />
              <label for="paragraph">Paragraph</label>
            </p>
            <div className="para-graph">
              <Radio
                options={[
                  { icon: Bullet, value: "circle" },
                  { icon: Square, value: "square" },
                  { icon: Dimond, value: "diamond" },
                  { icon: Pipeline, value: "lineVertical" },
                  { icon: Multiply, value: "cross" },
                ]}
                value={options.bullets}
                onChange={(val) => {
                  handleChange("bullets", val);
                  saveOptions();
                }}
                withIcon
                disabled={options.bullets === null}
              />
            </div>
          </div>
        </div>
        <div className="optionSection">

          <div className="optionSectionLabel">
            {options.bullets === null ? " Column width" : " Width"}
          </div>

          <div className="optionSectionContent column-widthNameonly ">
            {options.bullets === null ? (
              <NumberInput
                postLabel="%"
                value={options.column_width}
                onChange={(val) =>
                  handleChange(
                    "column_width",
                    conditionalColumnWidth(val, options)
                  )
                }
                min={15}
                max={100}
                onFocusOut={saveOptions}
              />
            ) : (
              <NumberInput
                postLabel="%"
                value={options.column_width}
                onChange={(val) => handleChange("column_width", val)}
                min={20}
                max={100}
                onFocusOut={saveOptions}
              />
            )}
          </div>

        </div>

        <div className="optionSection">
          <div className="optionSectionLabel">Balance</div>
          <div className="optionSectionContent ">
            <Radio
              options={[
                { icon: BalanceOff, value: null },
                { icon: BalanceCenter, value: "center" },
              ]}
              value={options.balance_columns}
              onChange={(val) => {
                handleChange("balance_columns", val);
                saveOptions();
              }}
              label={options.balance_columns === null ? "Off" : "Center"}
              withIcon
            />
          </div>
        </div>
        {
          !options?.bullets ? (
            <div className="optionSection">
              <div className="optionSectionLabel">Ordering</div>
              <div className="optionSectionContent">
                <Radio
                  options={[
                    { icon: ColumnHorizontal, value: "horizontal" },
                    { icon: ColumnVertical, value: "vertical" },
                  ]}
                  value={options.column_flow}
                  onChange={(val) => {
                    handleChange("column_flow", val);
                    saveOptions();
                  }}
                  label="Column flow"
                  withIcon
                />
              </div>
            </div>
          ) : null
        }

        {!options?.bullets ? (
          <div className="optionSection">
            <div className="optionSectionContent2">
              <Radio
                options={[
                  { icon: None, value: null },
                  { icon: AlphabeticalAtoZ, value: "ascending" },
                  { icon: AlphabeticalZtoA, value: "descending" },
                ]}
                value={options.column_order}
                onChange={(val) => {
                  handleChange("column_order", val);
                  saveOptions();
                }}
                label="Alphabetical"
                withIcon
              />
            </div>
          </div>
        ) : null}


        <hr className="border-b-2 border-white/[.6]" />
        <div className="optionSection">
          <div className="optionSectionLabel">Block Inset</div>
          <div className="optionSectionContent BLock-inset-nameonly">
            <Radio
              label={options.block_inset}
              // options={[
              //   {
              //     icon: InsetOff, value: "default",
              //     disabled: (options?.side_by_side === "on" && (options?.block_inset === "default" || options?.block_inset === "left" || options?.block_inset === "right"))
              //   },
              //   { icon: InsetLeft, value: "left" },
              //   { icon: InsetRight, value: "right" },
              //   { icon: SideAB, value: "sidebyside", disabled: options?.side_by_side === "on" },
              // ]}
              options={[
                {
                  icon: InsetOff, value: "default",
                  disabled: (options?.side_by_side === "on" &&
                    (options?.block_inset === "default" ||
                      options?.block_inset === "left" || options?.block_inset === "right"))
                },
                { icon: InsetLeft, value: "left", disabled: options?.side_by_side === "on" },
                { icon: InsetRight, value: "right", disabled: options?.side_by_side === "on" },
                { icon: SideAB, value: "sidebyside", disabled: options?.side_by_side === "on" },
              ]}
              value={options.block_inset}
              onChange={(val) => {
                handleChange("block_inset", val);
                saveOptions();
              }}
              withIcon
            />
          </div>
        </div>
        <div className="optionSection">
          <div className="optionSectionLabel">Margin</div>
          <div className="optionSectionContent">
            <div className="label-2 label-nameonly">Vertical</div>
            <Dropdown
              // label="Vertical"
              options={option}
              selectedID={selectedID}
              value={options.margin_vertical}
              onChange={(val) => {
                handleChange("margin_vertical", val);
                saveOptions();
              }}
            />
          </div>
        </div>
        <div className="optionSection">
          <div className="optionSectionContent2">
            <div className="label-1 label-nameonly">Bottom</div>
            <NumberInput
              // label="Bottom"
              value={options.extra_lines_below}
              min={0}
              max={25}
              onChange={(val) => handleChange("extra_lines_below", val)}
              onFocusOut={saveOptions}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NameOnly;